export default __webpack_public_path__ + "static/media/Seasons_13.b945da60.png";